// extracted by mini-css-extract-plugin
export default {"mobile":"600px","tablet":"800px","landscape_tablet":"1024px","desktop":"1440px"};